import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=770f2712&scoped=true&"
import script from "./footerPage.vue?vue&type=script&lang=js&"
export * from "./footerPage.vue?vue&type=script&lang=js&"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=770f2712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f2712",
  null
  
)

export default component.exports